export default {
  brand: "BasetaoSheet",
  nav: {
    spreadsheet: "Spreadsheet",
    guides: "Guides",
    categories: "Categories",
    review: "Review",
    shipping: "Shipping",
    home: "Home",
    faq: "FAQ",
    shoppingGuide: "Shopping Guide",
    visitMain: "Visit Main Website",
  },
  search: {
    placeholder: "Search Basetao Spreadsheet, sellers, shipping...",
  },
  cta: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Buy It Now",
    visitMain: "Visit Main Website",
    explore: "Explore",
  },
  lang: {
    label: "Language",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  notFound: {
    title: "Page Not Found",
    subtitle: "Sorry, the page you are looking for does not exist or may have been moved.",
    backHome: "Back to Home",
  },
  categories: {
    title: "Browse Product Categories",
    subtitle: "Explore every product group covered in the spreadsheet, each linked to the main catalog.",
    shoes: "Shoes",
    hoodies: "Hoodies / Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants / Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear / Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
    empty: "No categories match your search.",
  },
  footer: {
    tagline: "An independent resource hub for Basetao Spreadsheet guides, sellers, shipping, coupons and safety tips.",
    resources: "Resources",
    quickLinks: "Quick Links",
    disclaimer: "This site is an independent informational resource and is not affiliated with Basetao. Product links lead to the main website.",
    copyright: "© 2026 BasetaoSheet. All rights reserved.",
    privacy: "Privacy",
    terms: "Terms",
    contact: "Contact",
  },
};